export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Input:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Continue"])}
}